<template>
  <b-modal id="modal-customer-financial" centered hide-footer size="lg"
    class="custom__modal">

    <template #modal-title>
      <div class="d-flex justify-content-between align-items-center w-100">
        <div>Detail Pelanggan Belum Berbelanja</div>
        <div>
          <b-button @click="download" size="sm" variant="primary" class="ml-2">
            Download
          </b-button>
        </div>
      </div>
    </template>
    <!-- Empty state -->
    <div v-if="!dataCustomer || dataCustomer.length === 0" class="text-center py-3 text-muted">
      Tidak ada data pelanggan
    </div>

    <div v-else>
      <!-- Search Input -->
      <div class="px-2 mb-2">
        <b-form-input v-model="search" placeholder="Cari pelanggan..." class="custom__input"></b-form-input>
      </div>

      <!-- Table -->
      <div class="table-responsive custom__table-wrapper mt-2 px-2">
        <b-table :items="filteredCustomers" :fields="fields" bordered small hover responsive class="custom__table"
          :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
          <!-- Index column -->
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <!-- Name column -->
          <template #cell(name)="data">
            <div class="cell-name">
              {{ data.item.name }}
            </div>
          </template>

          <!-- Last Order column formatted -->
          <template #cell(last_order_date)="data">
            <span>
              {{ data.item.last_order_date ? moment(data.item.last_order_date).format("DD MMM YYYY") : "-" }}
            </span>
          </template>
        </b-table>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BTable, BButton, BFormInput } from "bootstrap-vue";
import moment from "moment";

export default {
  components: { BModal, BTable, BButton, BFormInput },
  props: {
    dataCustomer: {
      type: Array,
      default: () => [],
    },
    download: {
      type: Function,
    },
  },
  data() {
    return {
      moment,
      search: "",
      sortBy: "last_order_date",
      sortDesc: true, // Default: newest first
      fields: [
        { key: "index", label: "#", sortable: false },
        { key: "name", label: "Nama", sortable: true },
        { key: "phone_number", label: "No. HP", sortable: true },
        { key: "alias_name", label: "Nama Alias", sortable: true },
        { key: "address", label: "Alamat", sortable: true },
        { key: "customer_type", label: "Tipe Pelanggan", sortable: true },
        {
          key: "last_order_date",
          label: "Pembelian Terakhir",
          sortable: true,
          formatter: (value) =>
            value ? moment(value).format("YYYY-MM-DD") : "-",
        },
      ],
    };
  },
  computed: {
  //Trigger
    filteredCustomers() {
      if (!this.search) return this.dataCustomer;

      const searchLower = this.search.toLowerCase();
      return this.dataCustomer.filter((c) =>
        Object.values(c)
          .join(" ")
          .toLowerCase()
          .includes(searchLower)
      );
    },
  },
};
</script>

<style scoped>
.custom__modal .modal-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px !important;
}

.custom__table-wrapper {
  max-height: 60vh;
  overflow-y: auto;
}

.custom__table th,
.custom__table td {
  vertical-align: middle;
  text-align: left;
}

.cell-name {
  white-space: normal !important;
  min-width: 275px;
  line-height: 1.4;
}

.text-center button {
  min-width: 150px;
}
</style>
